import React, { useState } from 'react';
import Select from "react-select";
import { FaEdit, FaTrash } from "react-icons/fa";
import { FaPlus } from "react-icons/fa6";
import 'react-phone-input-2/lib/style.css';
import PhoneInput from 'react-phone-input-2';

const ContactDetails = ({ setContactList, contactList, addContactType, defaultCountry, readOnly = false }) => {

    const [formData, setFormData] = useState({
        type: null,
        contactPerson: '',
        phone: '',
        countryCode: '',
    });

    const [editIndex, setEditIndex] = useState(null);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleSelectChange = (selected) => {
        setFormData(prev => ({ ...prev, type: selected }));
    };

    const handleAddOrUpdate = () => {

        if (editIndex !== null) {
            // UPDATE
            const updatedList = [...contactList];
            updatedList[editIndex] = formData;
            setContactList(updatedList);
            setEditIndex(null);
        } else {
            // ADD
            setContactList(prev => [...prev, formData]);
        }

        setFormData({
            type: null,
            contactPerson: '',
            phone: '',
            countryCode: '',
        });
    };

    const handleEdit = (index) => {
        setFormData(contactList[index]);
        setEditIndex(index);
    };

    const handleDelete = (index) => {
        const filtered = contactList.filter((_, i) => i !== index);
        setContactList(filtered);
    };

    return (
        <div className="cost-center-section my-3">
            <div className="border-box2 p-3" style={{ borderRadius: '8px' }}>

                <div className="form-group grid-contain ">
                    {!readOnly && (
                    <>
                    <div className="d-flex">
                        <label className="form-label pt-1 start">Contact Type</label>
                        <Select
                            className="p-0 w-100"
                            theme={(theme) => ({
                                ...theme,
                                borderRadius: 5,
                                padding: 9,
                            })}
                            menuPortalTarget={document.body}
                            styles={{
                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                option: (provided, state) => ({
                                    ...provided,
                                    backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                    color: state.isFocused ? "#000 " : "#000",
                                    ":hover": {
                                        backgroundColor: "#F5F5F5",
                                        color: "#000 ",
                                    },
                                }),
                            }}
                            options={addContactType?.map(country => ({ value: country?.value, label: country?.text }))}
                            value={formData.type}
                            onChange={handleSelectChange}
                        />
                    </div>

                    <div className="d-flex">
                        <label className="form-label pt-1 start">Contact Person </label>
                        <input
                            type="text"
                            className="p-2 form-control w-75"
                            name="contactPerson"
                            value={formData.contactPerson}
                            onChange={handleInputChange}
                        />
                    </div>

                    <div className="d-flex">
                        <label className="form-label pt-1 start">Contact No </label>
                        <div style={{ width: '75%' }}>
                            <PhoneInput className="p-0"
                                country={defaultCountry}
                                value={formData.phone}
                                onChange={(value, country) => {
                                    setFormData(prev => ({
                                        ...prev,
                                        phone: value,
                                        countryCode: country.countryCode,
                                    }));
                                }}
                                enableSearch
                            />
                        </div>
                    </div>
                    </>
                    )}
                </div>

                {!readOnly && (
                <div className='my-4'>
                    <div
                        className='mainbtnSecondary flex-end gap-2 col-2'
                        style={{ cursor: "pointer" }}
                        onClick={handleAddOrUpdate}
                    >
                        <FaPlus color='#fff' className='center mt-1 mx-2' />
                        <div className='center'>
                            {editIndex !== null ? "Update Contact" : "Add Contact"}
                        </div>
                    </div>
                </div>
                )}

                <div className='table-container' style={{ overflowX: 'auto', height: "400px" }}>
                    <table className='table table-bordered gridshad'>
                        <thead className='dynoTable'>
                            <tr>
                                {!readOnly && <th>Action</th>}
                                <th>Contact Name</th>
                                <th>Designation</th>
                                <th>Contact No</th>
                            </tr>
                        </thead>
                        <tbody>
                            {contactList.map((data, index) => (
                                <tr key={index}>
                                    {!readOnly && (
                                    <td className="text-center d-flex gap-3">
                                        <div className='center mt-2'>
                                            <FaEdit
                                                size={20}
                                                style={{ cursor: "pointer", color: "black" }}
                                                onClick={() => handleEdit(index)}
                                            />
                                        </div>
                                        <div className='center mt-2'>
                                            <FaTrash
                                                size={20}
                                                style={{ cursor: "pointer", color: "red" }}
                                                onClick={() => handleDelete(index)}
                                            />
                                        </div>
                                    </td>
                                    )}
                                    <td>{data.contactPerson}</td>
                                    <td>{data.type?.label}</td>
                                    <td>{data.phone}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>

            </div>
        </div>
    );
};

export default ContactDetails;
